import { useEffect, useState } from 'react'
import { railgunEmitter } from '@web/utils/railgunListener'
import type { BatchListUpdateEvent } from '@railgun-community/wallet'

const useRailgunBatchUpdate = () => {
  const [batch, setBatch] = useState<BatchListUpdateEvent | null>(null)

  useEffect(() => {
    const handleBatchListUpdate = (event: BatchListUpdateEvent) => {
      setBatch(event)
      if (event.percent === 100) {
        setTimeout(() => {
          setBatch(null)
        }, 5000)
      }
    }
    railgunEmitter.on('batchListUpdate', handleBatchListUpdate)
    return () => {
      railgunEmitter.off('batchListUpdate', handleBatchListUpdate)
    }
  }, [])

  return batch
}

export default useRailgunBatchUpdate
